import script from "./HabitOptions20710.vue?vue&type=script&setup=true&lang=ts"
export * from "./HabitOptions20710.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__